import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NbFieldType} from "./nbinput.entity";

@Component({
    selector: 'nbinput-number',
    template: require('./nbinput-number.component.html'),
    styles: [require('./nbinput-number.component.scss')],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NbinputNumberComponent),
            multi: true
        }
    ]
})

export class NbinputNumberComponent implements ControlValueAccessor {
    private onTouchedCallback = () => {};
    private onChangeCallback = (_) => {};
    public FieldType = NbFieldType;
    registerOnChange(fn: any): void {if(fn)this.onChangeCallback = fn;}
    registerOnTouched(fn: any): void {if(fn)this.onTouchedCallback = fn;}
    setDisabledState?(isDisabled: boolean): void {this.disabled = isDisabled}
    writeValue(obj: number): void {
        if (this._data != obj) {
      setTimeout(()=> {
            this.data = obj;
      }, 0);
        }
    }
    onBlur() {
        this.onTouchedCallback();
    }
  @Output() public changed: EventEmitter<any> = new EventEmitter();
  onChange(event){
    this.changed.emit(this.data);
        this.onChangeCallback(this.data);
    }
    isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    public disabled;
    @Input()
    public readonly;
    public _calc:number;
    private PERCENT = new RegExp('^[0-9]+(.[0-9]+)?%$');
    @Input()
    set data(val: any) {
        // console.log('type=',this.type);
        let ex = val;
        if (this.PERCENT.test(val)){
            // console.log('%->',val);
            ex = parseFloat(val) / 100;
        }
        if (this.isNumeric(ex)){
            // console.log('ex: ',ex)
            ex = Math.round((ex*100 + 0.001) * 100) / 10000;
            if (this._data != ex) {
                // console.log('parse->',ex);
                this._data = ex;
                this.setData();
            }
        } else {
            this._data = null;
            this._calc = null;
        }
        // console.log('data = ',val,', calc = ',this._calc)
    }
    get data(): any {
        if (this.isNumeric(this._calc)){
      if (this._type == NbFieldType.Percentage) {
                // Percent：显示精确到小数点后2位，输出除以100(60.00%输出为0.6)。
                this._data = Math.round((this._calc*1 + 0.001) * 100) / 10000;
      } else if (this._type == NbFieldType.CurrencyFen) {
                // CurrencyFen：显示除以100且精确到小数点后2位，输出乘以100的纯整数(￥3.12输出为312)。
                this._data = Math.round((this._calc*1 + 0.001) * 100);
            } else {
                // Currency：显示精确到小数点后2位，输出与显示一致。
                // PercentFen：显示精确到小数点后2位，输出与显示一致(60%输出为60)。
                // 其他：显示与输出一致
                this._data = this._calc*1;
            }
        } else {
            this._data = null;
        }
        return this._data;
    };
    public _data:number = 0;
    get value(): any {
        return this.data;
    };
    set value(v: any) {
        if (v !== this.data) {
            this.data = v;
        }
    }
    setData(){
    if (this._type&&this.isNumeric(this._data)){
            // console.log('da: ',this._data, 'type: ',this.type)
            if (this._type == NbFieldType.Percentage) {
                // Percent：显示精确到小数点后2位，输出除以100(60.00%输出为0.6)。
                this._calc = this._data * 100;
                // console.log('percent->',this._calc);
            } else if (this._type == NbFieldType.CurrencyFen) {
                // CurrencyFen：显示除以100且精确到小数点后2位，输出乘以100的纯整数(￥3.12输出为312)。
        this._calc = this._data / 100;
                // console.log('curFen->',this._calc);
            } else {
                // Currency：显示精确到小数点后2位，输出与显示一致。
                // PercentFen：显示精确到小数点后2位，输出与显示一致(60%输出为60)。
                // 其他：显示与输出一致
                this._calc = this._data;
                // console.log('cur/perFen->',this._calc);
            }
            this.onChangeCallback(this._data);
        }
    }

    public _type:NbFieldType;
    @Input()
    set type(t:NbFieldType){
        this._type = t;
        // console.log('set type = ',t);
        this.setData();
    }

    @Input()
    placeholder:string = '';
}

